// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface DiscussionsMessageStatus
 */
export interface DiscussionsMessageStatus {
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsMessageStatus
     */
    allowed: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsMessageStatus
     */
    reason: DiscussionsMessageStatusReasonEnum;
}

export function DiscussionsMessageStatusFromJSON(json: any): DiscussionsMessageStatus {
    return {
        'allowed': json['allowed'],
        'reason': json['reason'],
    };
}

export function DiscussionsMessageStatusToJSON(value?: DiscussionsMessageStatus): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'allowed': value.allowed,
        'reason': value.reason,
    };
}

/**
* @export
* @enum {string}
*/
export enum DiscussionsMessageStatusReasonEnum {
    SenderBlockedReceiver = 'sender blocked receiver',
    ReceiverBlockedSender = 'receiver blocked sender',
    SenderMessagesDisabled = 'sender messages disabled',
    ReceiverMessagesDisabled = 'receiver messages disabled',
    TopicPendingSenderInitiated = 'topic pending sender initiated',
    TopicPendingReceiverInitiated = 'topic pending receiver initiated',
    CannotMessageOneself = 'cannot message oneself',
    TopicExists = 'topic exists',
    MentorMenteeRelationship = 'mentor mentee relationship',
    InSameClass = 'in same class',
    NewTopicOk = 'new topic ok'
}


